<template>
	<div class="calendar-header-container">
		<button type="button" class="arrow" v-on:click="changeMonth(1)"><</button>
		<p class="calendar-title">{{dateInformation.monthName}} {{year}}</p>
		<button type="button" class="arrow" v-on:click="changeMonth(2)">></button>
	</div>
</template>

<script>

	const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];

	function changeMonth(type) {
		this.$emit('change-month', type);
	}

	function dateInformation() {
		const information = {
			monthName: months[this.month - 1],
		};
		return information;
	}

	export default {
		name: 'calendar-header',
		computed: {
			dateInformation,
		},
		props: {
			month: {
				type: Number,
				default: 1,
			},
			year: {
				type: Number,
				default: 2017,
			},
		},
		methods: {
			changeMonth,
		},
	};
</script>

<style lang="scss" scoped>
.calendar-header-container {
	align-items: center;
	border: solid 2px map-get($colors, calendar-border);
	display: flex;
	justify-content: space-between;
	padding: 8px 10px;

	.arrow {
		color: map-get($colors, border-radio);
		font-size: 18px;
		font-weight: bold;
	}

	.calendar-title {
		color: map-get($colors, dark);
		font-family: map-get($fonts, regular);
		font-size: 14px;
		margin: 0;
		text-align: center;
	}
}
</style>


// WEBPACK FOOTER //
// CalendarHeader.vue?c3b1e828